import { Action } from "redux";
import { PlanListItem } from "../../../service/api-response/PlanListSuccessResponse";

export const GET_PLAN_LIST_FOR_ORGANIZATION_SUCCESS =
  "SUBSCRIPTION:GET_PLAN_LIST_FOR_ORGANIZATION_SUCCESS";

export interface GetPlanListForOrganizationSuccessAction extends Action {
  type: typeof GET_PLAN_LIST_FOR_ORGANIZATION_SUCCESS;
  organizationKeyName: string;
  data: PlanListItem[];
}

export const getPlanListForOrganizationSuccessAction = (
  organizationKeyName: string,
  data: PlanListItem[]
): GetPlanListForOrganizationSuccessAction => ({
  type: GET_PLAN_LIST_FOR_ORGANIZATION_SUCCESS,
  organizationKeyName,
  data,
});
